import React from 'react'
import ClientesInfo from './auxComponents/ClientesInfo/ClientesInfo'

export  const TabsData = [
    { name: 'Info.', component: <ClientesInfo /> }
    

]

